import { createGlobalStyle } from 'styled-components'
import tw from 'tailwind.macro'
import { colors } from '../../tailwind'

const GlobalStyle = createGlobalStyle`
  *, *:before, *:after {
    box-sizing: inherit;
  }
  html {
    ${tw`font-sans`};
    text-rendering: optimizeLegibility;
    overflow-x: hidden;
    box-sizing: border-box;
    -ms-overflow-style: scrollbar;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    background-color: ${colors['grey-lightest']};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  html, body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }
  a {
    color: ${colors['am-green-ally']};
    text-decoration: none;
    transition: color 0.15s ease;
  }
`

export default GlobalStyle
